import type { TMessage } from '~entities/messages';

import type { TransformedLastMessage } from './types';

export const processLastMessageText = (
	text: string,
	meta: TMessage['meta']
) => {
	if (meta?.videoDuration || meta?.['video-duration']) {
		return `${String.fromCodePoint(127749)} video`;
	}
	if (meta?.preview) {
		return `${String.fromCodePoint(127749)}  photo`;
	}
	if (meta?.hasAudio || meta?.['has-audio']) {
		return `${String.fromCodePoint(127908)} audio message`;
	}

	return text;
};

export const transformChatsMessage = (
	message: TMessage
): TransformedLastMessage => {
	const text = processLastMessageText(message.text, message.meta);
	const isSexting = /(photo|audio|video)/.test(text)
		? false
		: message.meta?.ranking?.labels?.includes('sexting') || false;

	const item = {
		id: message.id,
		senderId: message.sender,
		recipientId: message.recipient,
		text,
		isSexting,
		tarifficationType: message.meta?.tariffication?.type,
		paid: message.meta?.tariffication?.paid ?? false,
		cost: message.meta?.tariffication?.cost ?? 0,
		timestamp: message.timestamp,
	};

	return item;
};
